import { Stack, Typography } from '@datanomik/commons-ui';
import { WatchLater } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const SupportPanelAvailabilityArea = () => {
  const { t } = useTranslation();
  const label = t('Support Hours');
  const availability = t('Monday to Friday from 9am to 6pm.');

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: 'blue.lighter',
        padding: '8px',
        gap: '4px',
      }}
    >
      <WatchLater
        color="primary"
        sx={{
          fontSize: '18px',
        }}
      />
      <Typography fontWeight="500" fontSize="12px">
        {label}
      </Typography>
      <Typography fontWeight="400" color="text.secondary" fontSize="12px">
        {availability}
      </Typography>
    </Stack>
  );
};
